module.exports = __webpack_public_path__ + "static/media/mock-washinn1.225207aa.png";